import styled from "styled-components";

export const HrWrapper = styled.div`
  background: #EFEEEE;
  width: 100%;
  height: 2px;
`